var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, forwardRef } from "react";
import styled, { css } from "../../styled";
import pxToRem from "../../utils/px-to-rem";
import { createPolymorphicComponent } from "../../utils/types/polymorphic-component";
import { Button, iconSizeMap } from "../button-styled";
import { DEFAULT_SIZE } from "../constants";
const sizeStyleSelector = ({ size = DEFAULT_SIZE, theme, }) => {
    const { space } = theme._ui;
    const sizeStyles = {
        large: css `
      width: ${pxToRem(48)};
      height: ${pxToRem(48)};
    `,
        medium: css `
      width: ${pxToRem(40)};
      height: ${pxToRem(40)};
    `,
        small: css `
      width: ${pxToRem(32)};
      height: ${pxToRem(32)};
    `,
    };
    const paddingStyles = {
        large: css `
      padding: ${space.s3};
    `,
        medium: css `
      padding: ${space.s3};
    `,
        small: css `
      padding: ${space.s2};
    `,
    };
    return css `
    ${sizeStyles[size]}
    ${paddingStyles[size]}
  `;
};
const roundedStyleSelector = ({ rounded, theme, }) => {
    const { radii } = theme._ui;
    if (!rounded) {
        return;
    }
    return `border-radius: ${radii.full}`;
};
export const StyledButton = styled(Button).withConfig({
    shouldForwardProp: (prop) => !["rounded"].includes(prop),
}) `
  svg {
    flex-shrink: 0;
  }

  ${sizeStyleSelector}
  ${roundedStyleSelector}
`;
export const IconButton = forwardRef((_a, ref) => {
    var { icon, size = DEFAULT_SIZE } = _a, props = __rest(_a, ["icon", "size"]);
    return (React.createElement(StyledButton, Object.assign({ size: size }, props, { ref: ref }), icon && cloneElement(icon, { size: iconSizeMap[size] })));
});
export default createPolymorphicComponent(IconButton);
